export default __webpack_public_path__ + "static/media/mulher.b9f741d3.png";